import classes from './Faqs.module.scss';
import FaqsTabs from './tabs/Tabs';

export default function Faqs(props) {
    return (
        <div className={classes.oFaqSectionBlock}>
            <div className={`container`}>
                <div className={`${classes.oRow} row`}>
                    <h1 className={`${classes.aBlockTitle} aSectionTitle fnt42`}>{`FAQs`}</h1>
                </div>
            </div>
            <div>
                <FaqsTabs props={props} />
            </div>
        </div>
    );
}
